export class ArticleContainerPropertyDef {
  public static readonly STRETCH_LENGTH: string = 'stretchLength';
  public static readonly HEIGHT: string = 'height';
  public static readonly RELATIVE_OFFSET: string = 'relativeOffset';
  public static readonly ACCEPTING_CONNECTIONS: string = 'acceptingConnections';
  public static readonly RECTANGLE: string = 'rectangle';
  public static readonly ORIGINAL_META_ELEMENTS: string = 'originalMetaElements';
  public static readonly TEXT_ANGLE: string = 'textAngle';
  public static readonly ARTICLES_GUIDS_BETWEEN_ADAPTERS: string = 'articleGuidsBetweenAdapters';
}
